import HeroWithTitle from "./HeroWithTitle";

export default HeroWithTitle;
